module.exports = __webpack_public_path__ + "img/MES12Indice5.b6872ea5.png";